import React from 'react'

const ForgotPasswordContext = React.createContext();

export default ForgotPasswordContext;
